import './Text.css';

function PrivacyPolicy() {
  return (
    <div className="Container">
      <header className="Container-header">
        <h1>Privacy Policy</h1>
        <p><strong>Last updated:</strong> July 20, 2025</p>

        <p>
          This Privacy Policy describes how we collect, use, and disclose your personal information and your privacy rights.
        </p>

        <h2>Interpretation and Definitions</h2>
        <h3>Interpretation</h3>
        <p>Terms with capital letters are defined and apply to both singular and plural use.</p>

        <h3>Definitions</h3>
        <ul>
          <li><strong>Account:</strong> Your user account for our Service.</li>
          <li><strong>Application:</strong> Hang 10, our mobile app.</li>
          <li><strong>Company:</strong> Hang 10 ("We", "Us", "Our").</li>
          <li><strong>Country:</strong> United States.</li>
          <li><strong>Device:</strong> Any internet-connected device.</li>
          <li><strong>Personal Data:</strong> Identifiable information about a person.</li>
          <li><strong>Service:</strong> The Hang 10 app and related services.</li>
          <li><strong>You:</strong> The user of the Service.</li>
        </ul>

        <h2>Collecting and Using Your Data</h2>
        <h3>Types of Data</h3>
        <h4>Personal Data</h4>
        <p>We may collect:</p>
        <ul>
          <li>Email address</li>
          <li>Name</li>
          <li>Usage Data</li>
        </ul>

        <h4>Usage Data</h4>
        <p>Collected automatically—IP address, browser info, time spent, etc.</p>

        <h4>Mobile Data</h4>
        <p>May include device ID, location (with permission), diagnostics.</p>

        <h3>Use of Personal Data</h3>
        <ul>
          <li>To operate and maintain the Service</li>
          <li>To manage your Account</li>
          <li>To contact you or send updates</li>
          <li>To improve services</li>
          <li>For analytics or legal compliance</li>
        </ul>

        <h3>Sharing Your Data</h3>
        <ul>
          <li>With service providers</li>
          <li>In business transfers (mergers, acquisitions)</li>
          <li>With affiliates and business partners</li>
          <li>With consent</li>
        </ul>

        <h2>Retention</h2>
        <p>We retain data as long as necessary for legal, security, or functional reasons.</p>

        <h2>Transfer</h2>
        <p>Data may be processed outside your region with security measures in place.</p>

        <h2>Delete Your Data</h2>
        <p>You may request deletion, but some info may be retained if legally necessary.</p>

        <h2>Disclosure</h2>
        <ul>
          <li>Legal compliance</li>
          <li>Protecting rights or users</li>
          <li>Preventing fraud or abuse</li>
        </ul>

        <h2>Security</h2>
        <p>We take precautions but cannot guarantee 100% security of data transmission.</p>

        <h2>Children's Privacy</h2>
        <p>We do not knowingly collect data from children under 13.</p>

        <h2>Third-Party Links</h2>
        <p>We may link to other sites—review their privacy policies separately.</p>

        <h2>Changes</h2>
        <p>We may update this policy. Updates will be posted with a new "Last updated" date.</p>

        <h2>Contact Us</h2>
        <p>Email: <a href="mailto:app.hang10@gmail.com">app.hang10@gmail.com</a></p>
      </header>
    </div>
  );
}

export default PrivacyPolicy;
